import React, {useEffect, useState} from "react";

const FormAmenities = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  const [amenities, setAmenities] = useState([]);
  const fetchAmenities = async () => {
    const resp = await fetch('/account/listings/amenities.json');
    const data = await resp.json()
    setAmenities(data);
  }
  useEffect(() => {
    fetchAmenities()
  }, [])
  const existingAmenties = values.amenities || [];
  return (
    <React.Fragment>        
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3><i className="sl sl-icon-home"></i> Amenities</h3>
        </div>
        <div>
          <p>Use this section to show what your business support and offers to it's clients.
          </p>
        </div>
        <div className="checkboxes in-row amenities_checkbox">
          <ul>
            {
              amenities.map((am) => (
                <li key={am.id}>
                <input 
                  id={`check-${am.id}`} 
                  type="checkbox" 
                  defaultChecked={existingAmenties && existingAmenties.find((x) => (x===am.name))} 
                  name="amenities[]" value={`${am.name}`}
                  onChange={e => setFieldValue('amenities', e.target.checked ? [...existingAmenties, am.name] : existingAmenties.filter((x) => (x !== am.name)) )}
                />
                <label htmlFor={`check-${am.id}`}>{am.name}</label>
              </li>
              ))
            }        
      </ul>
    </div>
    </div>


    </React.Fragment>
  );
};

export default FormAmenities;
